module.exports = __webpack_public_path__ + "static/exam2-2a8c5bfc2597e5afc16cccd75ed2c47a.png";